var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Carousel, Slide } from 'vue-snap';
import { BImg } from 'bootstrap-vue';
var AttachmentSlider = /** @class */ (function (_super) {
    __extends(AttachmentSlider, _super);
    function AttachmentSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i18n = { slideLeft: 'Vorheriges Bild', slideRight: 'Nächstes Bild' };
        return _this;
    }
    AttachmentSlider.prototype.isActive = function (attachment) {
        if (this.activeAttachment) {
            return attachment.id === this.activeAttachment.id;
        }
        return false;
    };
    AttachmentSlider.prototype.getAltText = function (attachment) {
        return attachment.alt_text ? attachment.alt_text + ", vergr\u00F6sserte Ansicht" : "vergr\u00F6sserte Ansicht";
    };
    __decorate([
        Prop({
            default: function () { return []; },
        }),
        __metadata("design:type", Array)
    ], AttachmentSlider.prototype, "attachments", void 0);
    __decorate([
        Prop({
            default: null,
        }),
        __metadata("design:type", Object)
    ], AttachmentSlider.prototype, "activeAttachment", void 0);
    __decorate([
        Prop({
            default: 'attachments.title'
        }),
        __metadata("design:type", String)
    ], AttachmentSlider.prototype, "postTitle", void 0);
    AttachmentSlider = __decorate([
        Component({
            components: {
                Carousel: Carousel,
                Slide: Slide,
                BImg: BImg,
            },
        })
    ], AttachmentSlider);
    return AttachmentSlider;
}(Vue));
export default AttachmentSlider;
